(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-studies"]) return;
  try {
    
(function() {
  function revealCaseStudies() {
    var section = document.getElementById('case-studies-reveal');
    if (!section || section.classList.contains('is-visible')) return;
    section.classList.add('is-visible');
    setTimeout(function() {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
  }
  function hideCaseStudies() {
    var section = document.getElementById('case-studies-reveal');
    if (!section) return;
    var logos = document.querySelector('.b2b-social-proof');
    var targetY = logos ? logos.offsetTop : 0;
    section.classList.remove('is-visible');
    window.scrollTo({ top: targetY, behavior: 'instant' });
  }
  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-action="reveal-case-studies"]')) {
      revealCaseStudies();
    } else if (e.target.closest('[data-action="hide-case-studies"]')) {
      hideCaseStudies();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
